'use client';

import {
  ScrollText,
  House,
  Building2,
  Gavel,
  Handshake,
  BriefcaseBusiness,
  UsersRound,
  Ellipsis,
  MessageCircleQuestionIcon
} from 'lucide-react';
import { Gravestone } from '@/components/ui/gravestone-icon';

/**
 * Get the appropriate icon for a matter type
 */
export function getMatterTypeIcon(slug: string) {
  switch (slug) {
    case 'estate-administration':
      return Gravestone;
    case 'estate-planning':
      return ScrollText;
    case 'advice-general-advice':
    case 'estate-advice':
      return MessageCircleQuestionIcon;
    case 'lease':
    case 'conveyancing-sale':
    case 'conveyancing-purchase':
    case 'conveyancing-lease':
    case 'conveyancing-other':
      return House;
    case 'retirement-village-contract':
      return Building2;
    case 'estate-dispute':
    case 'criminal-law':
      return Gavel;
    case 'business':
    case 'sale-of-business':
    case 'purchase-of-business':
      return Handshake;
    case 'commercial-law-general':
      return BriefcaseBusiness;
    case 'family-law':
      return UsersRound;
    case 'litigation':
      return Gavel;
    case 'other':
    default:
      return Ellipsis;
  }
}
